export default __webpack_public_path__ + "static/media/Azazel-Fx-Pack-00.72650673.jpg";